import z from 'zod'
import { GeometrySchema } from '../../../@shared/infra/schemas/Geometry.schema'
import { FarmSchema } from './Farm.schema'
import { BandTypeEnum } from '../../domain/enums/BandType.enum'
import { GeoImageTypeEnum } from '../../domain/enums/GeoImageType.enum'
import { GeoImage } from '../../domain/entities/GeoImage'

export const GeoImageSchema = z
	.object({
		id: z.uuid(),
		codigo: z.number(),
		nome: z.string(),
		descricao: z.string(),
		infoFazenda: FarmSchema,
		dataDeAquisicao: z.preprocess((value: string) => new Date(value), z.date()),
		tipoDeImagem: z.enum(GeoImageTypeEnum),
		tamanhoDoPixel: z.string(),
		// chave com typo espelha o nome retornado pela API (IndentificadoresDasBandas no backend)
		// partialRecord: a API pode retornar mapeamento vazio ou parcial (ex. LIDAR/MDT sem bandas)
		indentificadoresDasBandas: z.partialRecord(z.enum(BandTypeEnum), z.string()),
		nomeArquivoSalvoNoAzureBlob: z.string(),
		numeroDeBandas: z.preprocess((value: string) => Number(value), z.number()),
		poligonoBordasImagem: GeometrySchema.optional(),
	})
	.transform(
		(data) =>
			new GeoImage(
				data.nome,
				data.infoFazenda,
				data.dataDeAquisicao,
				data.tipoDeImagem,
				data.nomeArquivoSalvoNoAzureBlob,
				data.tamanhoDoPixel,
				data.indentificadoresDasBandas,
				data.descricao,
				data.codigo,
				data.id,
				undefined,
				data.numeroDeBandas,
				data.poligonoBordasImagem,
			),
	)
